import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { colors } from '../constants/colors';
import { ArrowLeft, Mail } from 'lucide-react';

export function HelpPage() {
  useDocumentTitle('Help & Support');
  const navigate = useNavigate();

  return (
    <Layout>
      <div style={styles.container}>
        <div style={styles.content}>
          <button style={styles.backButton} onClick={() => navigate('/account')}>
            <ArrowLeft size={18} /> Back to Account
          </button>

          <h1 style={styles.title}>Help & Support</h1>

          <div style={styles.card}>
            <div style={styles.iconCircle}>
              <Mail size={28} color="#5F3DC4" />
            </div>
            <h2 style={styles.cardTitle}>Need help?</h2>
            <p style={styles.cardText}>
              Send us an email and we'll get back to you as soon as possible.
            </p>
            <a href="mailto:support@snagg.live" style={styles.emailLink}>
              support@snagg.live
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { padding: '24px' },
  content: { maxWidth: '600px', margin: '0 auto' },
  backButton: {
    display: 'flex', alignItems: 'center', gap: 6,
    background: 'none', border: 'none', cursor: 'pointer',
    color: colors.gray[600], fontSize: 14, fontWeight: 500,
    marginBottom: 16, padding: 0,
  },
  title: { fontSize: 28, fontWeight: 700, color: colors.ink.black, marginBottom: 24 },
  card: {
    backgroundColor: colors.white,
    borderRadius: 16,
    border: `1px solid ${colors.gray[300]}`,
    padding: '40px 24px',
    textAlign: 'center',
  },
  iconCircle: {
    width: 64, height: 64, borderRadius: '50%',
    background: 'rgba(95,61,196,0.10)',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: 16,
  },
  cardTitle: {
    fontSize: 20, fontWeight: 600, color: colors.ink.black, marginBottom: 8,
  },
  cardText: {
    fontSize: 15, color: colors.gray[600], lineHeight: 1.5, marginBottom: 16,
  },
  emailLink: {
    display: 'inline-block',
    fontSize: 16, fontWeight: 600, color: '#5F3DC4',
    textDecoration: 'none',
    padding: '12px 24px',
    backgroundColor: 'rgba(95,61,196,0.10)',
    borderRadius: 10,
  },
};
